import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = 'fromto'
const clientRoot = () => `${LocalStorage.getClientPrefix()}/fromto`

const encode = v => encodeURIComponent(Buffer.from(v).toString('base64'))

class FromToService {
  about () {
    return Api().get(`${clientRoot()}/about`)
  }

  insert (item) {
    const { collection } = item
    return Api().post(`${root}/${collection}`, item)
  }

  update (item) {
    const { collection, from } = item
    return Api().put(`${root}/${collection}/${encode(from)}`, item)
  }

  findAll (collection) {
    return Api().get(`${clientRoot()}`, { params: { collection } })
  }

  delete ({ collection, from }) {
    return Api().delete(`${clientRoot()}/${collection}/${encode(from)}`)
  }

  findById (collection, from) {
    return Api().get(`${clientRoot()}/${collection}/${encode(from)}`)
  }

  findAllCollections () {
    return Api().get(`${clientRoot()}/findAllCollections`)
  }
}

export default new FromToService()
